import './Nickname.scss';
import { NicknameParams } from './Nickname.type';

export default function Nickname(props: NicknameParams) {
  const { mode = 'small', nickname = '' } = props;

  return <span className={`nickname nickname--${mode}`}>{nickname}</span>;
}
